import { defineComponent as _defineComponent } from 'vue';
import { useTaskList } from '@blade-sxp/monitoring-center/pages/alarm/utils/useTaskList';
export default /*#__PURE__*/ _defineComponent({
    __name: 'task-list',
    setup(__props) {
        const { getTaskList, onTaskChange, taskList } = useTaskList();
        // 获取任务list
        getTaskList();
        return { __sfc: true, getTaskList, onTaskChange, taskList };
    }
});
